import React from "react";
import { Link } from "react-router-dom";

// Mobile items
const Mobile_data = [
  {
    id:1,
    img:'/assets/img/project/item-1.jpg',
    tag:"Business",
    title:"USSD"
  },
  {
    id:2,
    img:'/assets/img/project/item-2.jpg',
    tag:"Business",
    title:"Shortcodes"
  },
  {
    id:3,
    img:'/assets/img/project/item-3.jpg',
    tag:"Business",
    title:"Intern program"
  },
]

const MobileItems = () => {
  return (
    <>
      <div className="project-page-list pt-140 pb-90">
        <div className="container">
          <div className="row">
            {Mobile_data.map((item) => (
            <div key={item.id} className="col-lg-4 col-md-6 col-12">
              <div className="pj-list-item mb-50">
                <div className="pj-list__img">
                  <img src={item.img} alt="" />
                </div>
                <span>
                  <a href="https://onfonmedia.com">{item.tag}</a>
                </span>
                <h4 className="pj-list__title">
                  <Link to="/mobile-vas-details">{item.title}</Link>
                </h4>
              </div>
            </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileItems;
